<template>
  <div class="main">
    <div class="testMsg">首页</div>
  </div>
</template>
<script>
import Vue from "vue";
import { Tag, NavBar, Toast, Popover } from "vant";
import { inBrowser, UA, isIOS, weexPlatform } from "../../utils/envUtils";
import { testApi } from "@/request/api";
Vue.use(Tag, NavBar, Toast, Popover);
export default {
  data() {
    return {};
  },
  components: {},
  created() {},
  mounted() {},
  methods: {
  },
};
</script>
<style lang="scss" scope="scoped">
.testMsg {
  font-size:0.12rem;
}
</style>


// WEBPACK FOOTER //
// src/pages/main.vue